import React, { useCallback } from 'react';
import dynamic from 'next/dynamic';
import { useIdleCallback } from '@shopify/react-idle';
import withSession from '@/lib/withSession';
import withAuth from '@/lib/withAuth';
import ecommerce from '@/seo/Ecommerce';
import { Loader } from '@/components';

const UserPage = dynamic(() => import('../../layouts/UserPage'), {
	loading: () => <Loader />,
});

export default function NextUserReturnsPage() {
	const setPageType = useCallback(() => {
		ecommerce.setPageType(ecommerce.PAGE_TYPES.PROFILE);
	}, []);

	useIdleCallback(setPageType);

	return <UserPage type='user-returns' />;
}

NextUserReturnsPage.getInitialProps = withSession(withAuth(() => ({})));
